module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSuperHeavy.2f1a329.woff2";